export class UpdateBuyNowTransactionModel {
    public buyNowTransactionId: string;
    public mobileNumber: string;
    public email: string;
}
